module.exports = __webpack_public_path__ + "static/media/bannersports.d485c440.webp";